import { Component, Input, OnInit } from '@angular/core';
import { AbstractWriterListComponentStore } from '../../../../../../../core/state/base-component-stores/abstract-writer-list.component-store';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';

@Component({
  selector: 'app-w-rating-comments-list',
  templateUrl: './w-rating-comments-list.component.html',
  styleUrls: ['./w-rating-comments-list.component.scss'],
})
export class WRatingCommentsListComponent implements OnInit {
  @Input() componentStore: AbstractWriterListComponentStore<any>;

  columns = ['owner', 'rate', 'comment'];

  constructor() {}

  ngOnInit(): void {}

  pageEvent(pageEvent: PageEvent) {
    this.componentStore.pageEvent(pageEvent);
  }
}
